// data
import {
    REDUX_FORM_AUTO_SAVE_ADD_SITE,
    REDUX_FORM_AUTO_SAVE_REMOVE_SITE,
    REDUX_FORM_MODAL_FORM_SHOW_SITE,
    REDUX_FORM_REFRESH_LEARN_PAGE_SITE,
    REDUX_FORM_SET_AVAILABILITY_SITE,
    REDUX_FORM_SET_COLLAPSE_STYLES_SITE,
    REDUX_FORM_SET_DATA_SITE,
    REDUX_FORM_SET_DYNAMIC_TEXT_OPTIONS_SITE,
    REDUX_FORM_SET_HOVERED_BLOCK_ID_SITE,
    REDUX_FORM_SET_IS_EDITING_SITE,
    REDUX_FORM_SET_IS_SUCCESS_MODAL_OPEN_SITE,
    REDUX_FORM_SET_IS_SUCCESS_TOAST_OPEN_SITE,
    REDUX_FORM_SET_NAVIGATION_MODE_SITE,
    REDUX_FORM_SET_PAGE_LIST_SITE,
    REDUX_FORM_SET_PARENT_ACTIVE_SITE,
    REDUX_FORM_SET_PERMISSIONS_SITE,
    REDUX_FORM_SET_REFRESH_SITE,
    REDUX_FORM_SET_SECTION_COLLAPSE_SITE,
    REDUX_FORM_SET_SECTION_ID_SITE,
    REDUX_FORM_SHOW_EDIT_ALERT_SITE,
} from './mo_actions'
import {
    reduxFormStateSite,
} from './mo_state'

// serializers
import {
    MainIdNameSerializer,
} from 'serializers/site'

// main
const initialState: reduxFormStateSite = {
    availableContentSources: [],
    collapseStyles: true,
    dynamicTextOptions: undefined,
    editAutoSave: {},
    editAutoSaved: {},
    editFunction: undefined,
    editUrl: undefined,
    editingForm: false,
    hoveredBlockId: undefined,
    isSuccessModalMessage: undefined,
    isSuccessModalOpen: false,
    isSuccessToastMessage: undefined,
    isSuccessToastOpen: false,
    modalForm: undefined,
    navigationMode: undefined,
    pageContentItems: undefined,
    pageObject: undefined,
    parentContent: undefined,
    permissions: undefined,
    portfolioObject: undefined,
    sectionCollapse: false,
    sectionId: undefined,
    showEditAlert: false,
    refresh: {
        PrivateDetailPageSite: 0,
    },
    refreshId: {
        PrivateDetailPageSite: undefined,
    },
    refreshNoEmpty: undefined,
    refreshLearnPage: undefined,
}

export default (state = initialState, action: any) => {
    switch (action.type) {
        case REDUX_FORM_AUTO_SAVE_ADD_SITE: {
            return {
                ...state,
                editAutoSave: {
                    ...state.editAutoSave,
                    [action.payload.contentId]: {
                        styles: action.payload.styles,
                        styles_original: action.payload.styles_original,
                        udpdateUrl: action.payload.udpdateUrl,
                    },
                }
            }
        }
        case REDUX_FORM_AUTO_SAVE_REMOVE_SITE: {
            const newEditAutoSave = Object.assign({}, state.editAutoSave)
            delete newEditAutoSave[action.payload.contentId]
            if (action.payload.cancel) {
                return {
                    ...state,
                    editAutoSave: newEditAutoSave,
                }
            }
            return {
                ...state,
                editAutoSave: newEditAutoSave,
                editAutoSaved: {
                    ...state.editAutoSaved,
                    [action.payload.contentId]: state.editAutoSave[action.payload.contentId]
                },
            }
        }
        case REDUX_FORM_MODAL_FORM_SHOW_SITE: {
            const newAlreadyOpenIds = state.modalForm?.alreadyOpenIds || []
            if (action.payload.blockId) {
                if (newAlreadyOpenIds.includes(action.payload.blockId)) {
                    return state
                }
                newAlreadyOpenIds.push(action.payload.blockId)
            }
            return {
                ...state,
                modalForm: {
                    alreadyOpenIds: newAlreadyOpenIds,
                    contentType: action.payload.contentType,
                    isOpen: action.payload.isOpen,
                    objectId: action.payload.objectId,
                },
            }
        }
        case REDUX_FORM_REFRESH_LEARN_PAGE_SITE: {
            return {
                ...state,
                refreshLearnPage: Math.random(),
            }
        }
        case REDUX_FORM_SET_AVAILABILITY_SITE: {
            return {
                ...state,
                availableContentSources: action.payload.content_sources,
            }
        }
        case REDUX_FORM_SET_COLLAPSE_STYLES_SITE: {
            return {
                ...state,
                collapseStyles: action.payload,
            }
        }
        case REDUX_FORM_SET_DATA_SITE: {
            return {
                ...state,
                [action.payload.branch]: action.payload.content,
            }
        }
        case REDUX_FORM_SET_DYNAMIC_TEXT_OPTIONS_SITE: {
            const dynamicTextOptionsObj: {
                [key: number]: MainIdNameSerializer[]
            } = {}
            action.payload.map((val: any) => {
                dynamicTextOptionsObj[val.id] = val.options
            })
            return {
                ...state,
                dynamicTextOptions: dynamicTextOptionsObj,
            }
        }
        case REDUX_FORM_SET_HOVERED_BLOCK_ID_SITE: {
            return {
                ...state,
                hoveredBlockId: action.payload,
            }
        }
        case REDUX_FORM_SET_IS_EDITING_SITE: {
            if (action.payload.styles_original) {
                return {
                    ...state,
                    navigationMode: 'edit',
                }
            }
            if (action.payload.boolean) {
                return {
                    ...state,
                    editingForm: action.payload,
                    navigationMode: 'edit',
                }
            }
            return {
                ...state,
                editingForm: action.payload,
            }
        }
        case REDUX_FORM_SET_IS_SUCCESS_MODAL_OPEN_SITE: {
            return {
                ...state,
                isSuccessModalMessage: action.payload.message,
                isSuccessModalOpen: action.payload.value,
            }
        }
        case REDUX_FORM_SET_IS_SUCCESS_TOAST_OPEN_SITE: {
            return {
                ...state,
                isSuccessToastMessage: action.payload.message,
                isSuccessToastOpen: action.payload.value,
            }
        }
        case REDUX_FORM_SET_NAVIGATION_MODE_SITE: {
            return {
                ...state,
                navigationMode: action.payload,
            }
        }
        case REDUX_FORM_SET_PAGE_LIST_SITE: {
            return {
                ...state,
                portfolioObject: {
                    ...state.portfolioObject,
                    pages: action.payload,
                },
            }
        }
        case REDUX_FORM_SET_PARENT_ACTIVE_SITE: {
            return {
                ...state,
                parentContent: action.payload,
            }
        }
        case REDUX_FORM_SET_PERMISSIONS_SITE: {
            let permissionIsDisabledRest = false
            let permissionIsDisabledText = false
            if (!action.payload?.portfolio_can_edit_rest) {
                permissionIsDisabledRest = true
                permissionIsDisabledText = false
            }
            return {
                ...state,
                permissions: {
                    permissionIsDisabledRest,
                    permissionIsDisabledText,
                },
            }
        }
        case REDUX_FORM_SET_REFRESH_SITE: {
            return {
                ...state,
                refresh: {
                    ...state.refresh,
                    [action.payload.refreshType]: action.payload.refreshValue,
                },
                refreshId: {
                    ...state.refreshId,
                    [action.payload.refreshType]: action.payload.refreshId,
                },
                refreshNoEmpty: action.payload.noEmpty,
            }
        }
        case REDUX_FORM_SET_SECTION_COLLAPSE_SITE: {
            return {
                ...state,
                sectionCollapse: action.payload,
            }
        }
        case REDUX_FORM_SET_SECTION_ID_SITE: {
            return {
                ...state,
                sectionId: action.payload,
            }
        }
        case REDUX_FORM_SHOW_EDIT_ALERT_SITE: {
            return {
                ...state,
                editFunction: action.payload.editFunction,
                editUrl: action.payload.editUrl,
                showEditAlert: action.payload.showEditAlert,
            }
        }
        default:
            return state
    }
}
